import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Box, Flex, Input, Icon } from '@elparking/components'

import matchWords from 'commons/js/util/matchWords'

import styled from 'styled-components'

const DEFAULT_MIN_LENGTH_SEARCH = 3

const BoxShadow = styled.div`
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
`

const mustShowItem = (name, searchText, minLengthSearch) => {
    if (searchText.length === 0 || searchText.length < minLengthSearch) {
        return true
    }
    return matchWords(searchText, name)
}

class ListSearcher extends React.Component {
    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string,
            link: PropTypes.string,
        })),
        placeholder: PropTypes.string,
        minLengthSearch: PropTypes.number.isRequired,
    }

    static defaultProps = {
        items: [],
        placeholder: '',
        minLengthSearch: DEFAULT_MIN_LENGTH_SEARCH,
    }

    state = {
        search: '',
        inputValue: '',
    }

    onSearch (search) {
        this.setState({
            search,
        })
    }

    onSearch = this.onSearch.bind(this)

    renderResult (item, key) {
        return (
            <Box key={key} w={['100%', '50%', '33%']} pb='8px'>
                <a rel='noopener noreferrer' target='_blank' href={item.link}>
                    <Copy color='gray' size='medium' fontWeight='book' decoration='underline'>
                        {item.name}
                    </Copy>
                </a>
            </Box>
        )
    }

    renderResults (items) {
        return items
            .filter(({name}) => mustShowItem(name, this.state.search, this.props.minLengthSearch))
            .map((item, i) => this.renderResult(item, i))
    }

    render () {
        return (
            <div>
                <Box pb='32px' pt='8px' w={['100%', '60%']}>
                    <BoxShadow>
                        <Input
                          leftIcon={<Box ml='16px'><Icon type='len' size='large' color='gray' /></Box>}
                          height='64px'
                          placeholder={this.props.placeholder}
                          onChange={this.onSearch}
                          dataTest='searcher-parking-meter'
                          value={this.state.search}
                        />
                    </BoxShadow>
                </Box>
                <Flex flexWrap='wrap' width='100%'>
                    {this.renderResults(this.props.items)}
                </Flex>
            </div>
        )
    }
}

export default ListSearcher
